export const ENABLED_OPTION_SELECTOR =
  '[data-listbox-option]:not([aria-disabled="true"])'

export const SELECTED_OPTION_SELECTOR = '[data-listbox-option][aria-selected="true"]'

export const SELECT_EVENT_NAME = 'listbox-select'
